import { jsx as _jsx } from "react/jsx-runtime";
import { Spin } from 'antd';
import './style.css';
var Loader = function (props) {
    var className = props.className || (props.renderSpinner ? 'loader-container-height' : undefined);
    return (_jsx("div", { className: className, children: props.renderSpinner ? (_jsx("div", { className: "loader-container", children: _jsx(Spin, { size: "large" }) }))
            :
                (props.children) }));
};
export default Loader;
